import Translator from "./model/Translator";

const translator = Translator.getInstance();

export default translator;
